/* Redux Toolkit */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* Axios */
import axiosInterceptor from "src/utils/helper/axios-interceptor";

export const fetchUserRoles = createAsyncThunk(
  "auth/userRoles",
  async () => {
    try {
      const response = await axiosInterceptor.get<string[]>(
        "/user_roles"
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
);
